import QUESTION_TYPE from "enums/QUESTION_TYPE";
import ROLE from "enums/ROLE_NAME";
import SCRIPT_STATUS from "enums/SCRIPT_STATUS";
import SCRIPT_TYPE from "enums/SCRIPT_TYPE";
import useScriptManagementStore from "features/ScriptManagement/hooks/useScriptManagementStore";
import useCurrentUser from "hooks/useCurrentUser";
import { useCallback } from "react";
import ScriptDto from "types/ScriptDto";
import { hasRole } from "utils/roles";

export default function useFormHelpers() {
  const { script, handleStoreChange } = useScriptManagementStore();
  const { role } = useCurrentUser();

  const updateStateFromScript = useCallback((script: ScriptDto) => {
    handleStoreChange("script", script);
  }, []);

  const isDraggable = (type: QUESTION_TYPE) => {
    return !(
      type === QUESTION_TYPE.THANKYOU ||
      type === QUESTION_TYPE.WELCOME ||
      type === QUESTION_TYPE.CONSENT
    );
  };

  const isOptionType = (type: QUESTION_TYPE) => {
    return (
      type === QUESTION_TYPE.MULTIPLE_CHOICE ||
      type === QUESTION_TYPE.SINGLE_CHOICE
    );
  };

  const isModerated = () => {
    return (
      script.type === SCRIPT_TYPE.MODERATED ||
      script.type === SCRIPT_TYPE.FOCUS_GROUP
    );
  };

  const isMobilePublished = () => {
    return (
      script.type === SCRIPT_TYPE.MOBILE &&
      script.status === SCRIPT_STATUS.PUBLISHED
    );
  };

  const scriptTypes = [
    { id: SCRIPT_TYPE.MOBILE, name: "Mobile" },
    { id: SCRIPT_TYPE.FOCUS_GROUP, name: "Focus Group" },
    { id: SCRIPT_TYPE.MODERATED, name: "Moderated" },
  ].filter((scriptType) => {
    if (
      hasRole(ROLE.SUPER_DUPER_ADMIN, role) ||
      hasRole(ROLE.SUPER_ADMIN, role)
    ) {
      return true;
    }
    return scriptType.id !== SCRIPT_TYPE.FOCUS_GROUP;
  });

  const questionTypes = [
    { id: QUESTION_TYPE.VIDEO, name: "Video Question" },
    { id: QUESTION_TYPE.MESSAGE, name: "Message" },
    { id: QUESTION_TYPE.TEXT, name: "Text Answer" },
    { id: QUESTION_TYPE.NUMERIC, name: "Numeric Answer" },
    { id: QUESTION_TYPE.SINGLE_CHOICE, name: "Single Choice" },
    { id: QUESTION_TYPE.MULTIPLE_CHOICE, name: "Multiple Choice" },
  ];

  return {
    scriptTypes,
    questionTypes,
    isModerated,
    isMobilePublished,
    isOptionType,
    isDraggable,
    updateStateFromScript,
    payload: { ...script },
  };
}
